const Tag = ({ children }) => `<${children}>`
export default Tag;